import axios from "axios";

// Backend хаяг. Локал backend-тэй холбогдохын тулд .env.local файлд
// REACT_APP_API_URL=http://192.168.1.100:4000 гэж бичээд dev server-ээ дахин асаана.
// Тохируулаагүй үед production руу холбогдоно.
export const API_URL = process.env.REACT_APP_API_URL || "https://api.erdenet24.mn";

// Нэвтрэлт дууссаныг UI-д мэдэгдэх event — components/authExpiredOverlay.js сонсоно.
export const AUTH_EXPIRED_EVENT = "e24:auth-expired";

// Эдгээр endpoint нь БУРУУ НУУЦ ҮГЭНД 401 буцаадаг (токен хүчинтэй хэвээр) —
// backend modules/merchant/merchant.controller.js: merchantLogin, verifyPassword,
// createProductDiscount, cancelProductDiscount, createBonusRule.
// Тэдний 401-ийг "нэвтрэлт дууссан" гэж үзвэл нууц үгээ андуурсан merchant
// системээс гарна.
const PASSWORD_CHECK_PATHS = [
  "/merchant/login",
  "/merchant/password/verify",
  "/merchant/createProductDiscount",
  "/merchant/cancelProductDiscount",
  "/merchant/createBonusRule",
];

// Хугацаа нь дууссаныг аль хэдийн мэдэгдсэн токен. Зэрэг явсан хэд хэдэн хүсэлт
// (захиалга, баннер, статистик...) нэг токеноор 401 авахад event НЭГ л удаа явна.
let notifiedExpiredToken = null;

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  responseType: "json",
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    // Authorization header
    if (token && !config.isAuthHost && config.isProtected !== false) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      };
      // Ямар токеноор явсныг тэмдэглэнэ — 401 ирэхэд зөвхөн тэр токеныг устгана
      config.sentToken = token;
    }

    // Remove Content-Type when uploading form-data
    if (config.isForm) {
      // Axios will set correct multipart/form-data with boundary
      delete config.headers["Content-Type"];
    }

    // Old skipContentType support
    if (config.skipContentType) {
      delete config.headers["Content-Type"];
    }

    return config;
  },
  (error) => Promise.reject(error),
);

function isPasswordCheckRequest(config) {
  const path = String(config?.url || "").split("?")[0];
  return PASSWORD_CHECK_PATHS.some((p) => path.endsWith(p));
}

// Токен хүчингүй болсон эсэх: D14 гэрээний `401 {type:'INVALID_TOKEN'}` эсвэл
// auth middleware-ийн 401. Нууц үг шалгадаг endpoint-уудын 401-ийг тооцохгүй.
function isAuthExpiredError(error) {
  const errRes = error?.response;
  if (!errRes) return false; // сүлжээний алдаа — нэвтрэлттэй хамаагүй
  if (errRes.data?.type === "INVALID_TOKEN") return true;
  if (errRes.status !== 401) return false;
  return !isPasswordCheckRequest(error.config);
}

function handleAuthExpired(sentToken) {
  const currentToken = localStorage.getItem("token");

  // Хүсэлт явсны дараа дахин нэвтэрч шинэ токен авсан бол хуучин токены
  // хоцорсон 401-ийг үл тооно — шинэ токеныг устгахгүй.
  if (currentToken && currentToken !== sentToken) return;
  if (currentToken) localStorage.removeItem("token");

  // Нэг токенд нэг л удаа мэдэгдэнэ (debounce)
  if (sentToken === notifiedExpiredToken) return;
  notifiedExpiredToken = sentToken;
  window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT));
}

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // Токентой явсан хүсэлт л тооцогдоно (нэвтрэх хуудас г.м. токенгүй хүсэлт биш)
    const sentToken = error?.config?.sentToken;
    if (sentToken && isAuthExpiredError(error)) {
      console.warn(
        "Нэвтрэлт дууссан:",
        error.response.status,
        error.response.data,
      );
      handleAuthExpired(sentToken);
    }

    return Promise.reject(error);
  },
);

export function AxiosRequest(options) {
  return axiosInstance({
    url: options.url || "/",
    method: options.method || "get",
    headers: options.headers,
    params: options.params,
    data: options.data,
    responseType: options.responseType,
    baseURL: options.apiUrl || API_URL,

    // Custom flags
    isAuthHost: options.isAuthHost,
    isProtected: options.isProtected,
    isForm: options.isForm, // ✔ upload flag
    skipContentType: options.skipContentType,
  });
}

export default AxiosRequest;
